import { ChevronRight } from "lucide-react";
import { ProfileForm } from "@/components/profile/ProfileForm";

export function ProfilePage() {
  return (
    <>
      <div className="topbar">
        <div className="topbar__crumbs">
          <span>Account</span>
          <ChevronRight size={14} />
          <strong>Profile</strong>
        </div>
      </div>
      <div className="page">
        <div className="page-header">
          <div>
            <h1 className="page-header__title">My Profile</h1>
            <p className="page-header__sub">Manage your display name and password.</p>
          </div>
        </div>
        <ProfileForm />
      </div>
    </>
  );
}
